import { locales } from './locales.js'
import { translatedPath } from './paths.js'

export const REALISATION_PAGE = 'magasin-excideuil/realisations/_slug'
export const REALISATION_ROUTE_NAME = 'magasin-excideuil-realisations-slug'

const DEFAULT_LOCALE = 'fr'

export const realisationSlug = (slugs, locale) =>
  slugs?.[locale] || slugs?.[DEFAULT_LOCALE] || null

export function realisationPath(pathTranslations, locale, slug) {
  const pattern = translatedPath(pathTranslations, locale, REALISATION_PAGE)
  if (!pattern || !slug) return null
  const prefix = locale === DEFAULT_LOCALE ? '' : `/${locale}`
  return `${prefix}${pattern.replace(':slug', encodeURIComponent(slug))}`
}

export const canonicalRealisationPath = (pathTranslations, locale, slugs) =>
  realisationPath(pathTranslations, locale, realisationSlug(slugs, locale))

export const realisationAlternates = (pathTranslations, slugs) =>
  locales.reduce((alternates, { code }) => {
    const path = canonicalRealisationPath(pathTranslations, code, slugs)
    return path ? { ...alternates, [code]: path } : alternates
  }, {})

const comparablePath = path => {
  const withoutQuery = String(path || '').split(/[?#]/)[0]
  const trimmed =
    withoutQuery.length > 1 ? withoutQuery.replace(/\/+$/, '') : withoutQuery
  try {
    return decodeURI(trimmed)
  } catch {
    return trimmed
  }
}

export function realisationRedirect({
  pathTranslations,
  locale,
  slugs,
  requestedPath,
}) {
  const canonical = canonicalRealisationPath(pathTranslations, locale, slugs)
  if (!canonical) return null
  return comparablePath(requestedPath) === comparablePath(canonical)
    ? null
    : canonical
}
